<template>
    <div>

        <div class="container mb-4">

            <h2 class="k-h-secondary">Komentáře ({{ commentsCount || 0 }})</h2>

            <document-comment-form
                    ref="commentForm"
                    :url="submitUrl"
                    :method="submitMethod"
                    @commentAdded="getDataAndScroll"
            ></document-comment-form>

        </div>

        <div class="container mb-3">

            <transition-group name="list-complete" tag="div">
                <template v-for="comment in comments">

                    <div :key="comment.id" :ref="`comment-${comment.id}`" class="k-panel k-panel--grid mb-3">
                        <div class="k-panel__body--3-4 k-border-right">
                            <div class="k-panel__body ">
                                {{ comment.content }}
                            </div>


                            <div class="k-panel__footer justify-content-between align-items-center">
                                <div class="k-panel__footer-btn">
                                    <a
                                            @click="$refs.commentForm.reactOnComment(comment)"
                                            href="javascript:;"
                                            class="k-action mr-3"
                                    >
                                        <svg class="" role="img" width="12" height="11">
                                            <use fill="currentColor" xlink:href="/images/spritesheet.svg#reply"></use>
                                        </svg>
                                        Reagovat
                                    </a>

                                    <a
                                            @click="likeComment(comment)"
                                            href="javascript:;"
                                            class="k-action"
                                            :class="[{'k-action--disabled': comment.like_url === null}]"
                                    >
                                        <svg class="" role="img" width="12" height="11">
                                            <use fill="currentColor" xlink:href="/images/spritesheet.svg#like"></use>
                                        </svg>
                                        Poděkovat autorovi ({{ comment.likes_count }})
                                    </a>
                                </div>


                                <a v-if="comment.delete_url !== null"
                                   @click="deleteComment(comment)"
                                   href="javascript:;"
                                   class="k-action k-action--control-danger k-panel__footer-btn k-panel__footer-btn--no-flex"
                                >
                                    <svg class="" role="img" width="12" height="11">
                                        <use fill="currentColor" xlink:href="/images/spritesheet.svg#add"></use>
                                    </svg>
                                    Odstranit komentář
                                </a>
                            </div>
                        </div>

                        <div class="k-panel__body k-panel__body--1-4 border-bottom-0">

                            <div class="k-user-contact">
                                <div class="k-user-contact__image">
                                    <img :src="comment.user.prev_url" >
                                </div>

                                <div class="k-user-contact__meta">
                                    <a :title="comment.user.name" :href="comment.user.detail_url">
                                        <div class="k-user-contact__name">
                                            {{ comment.user.name }}
                                        </div>
                                    </a>

                                    <div class="k-user-contact__date">
                                        Vloženo: {{ comment.created_at }}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div :key="reaction.id" :ref="`comment-${reaction.id}`" v-for="reaction in comment.reactions" class="k-panel k-panel--grid mb-3 k-panel--loffset-1">
                        <div class="k-panel__body--3-4-fluid k-border-right">
                            <div class="k-panel__body ">
                                {{ reaction.content }}
                            </div>
                            <div class="k-panel__footer justify-content-between align-items-center">
                                <div class="k-panel__footer-btn">
                                    <a @click="$refs.commentForm.reactOnComment(reaction)" href="javascript:;" class="k-action mr-3"><svg role="img" width="12" height="11" class=""><use fill="currentColor" xlink:href="/images/spritesheet.svg#reply"></use></svg>
                                        Reagovat
                                    </a>
                                    <a @click="likeComment(reaction)" href="javascript:;" class="k-action" :class="[{'k-action--disabled': reaction.like_url === null}]"><svg role="img" width="12" height="11" class=""><use fill="currentColor" xlink:href="/images/spritesheet.svg#like"></use></svg>
                                        Poděkovat autorovi ({{ reaction.likes_count }})
                                    </a>
                                </div>
                                <a v-if="reaction.delete_url !== null" @click="deleteComment(reaction)" href="javascript:;" class="k-action k-action--control-danger k-panel__footer-btn k-panel__footer-btn--no-flex"><svg role="img" width="12" height="11" class=""><use fill="currentColor" xlink:href="/images/spritesheet.svg#add"></use></svg>
                                    Odstranit komentář
                                </a>
                            </div>
                        </div>
                        <div class="k-panel__body k-panel__body--1-4-fix border-bottom-0">
                            <div class="k-user-contact">
                                <div class="k-user-contact__image">
                                    <img :src="reaction.user.prev_url" alt="">
                                </div>
                                <div class="k-user-contact__meta">
                                    <a :title="reaction.user.name" :href="reaction.user.detail_url">
                                        <div class="k-user-contact__name">
                                            {{ reaction.user.name }}
                                        </div>
                                    </a>
                                    <div class="k-user-contact__date">
                                        Vloženo: {{ reaction.created_at }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </template>
            </transition-group>


        </div>
    </div>
</template>

<script>
    import DocumentCommentForm from '../../forms/documents/DocumentCommentForm';
    export default {
        components: {
            DocumentCommentForm

        },

        props: {
            /**
             * Urls
             */
            commentsUrl: {
                type: String,
                required: true
            },
            submitUrl: {
                type: String,
                required: true
            },
            submitMethod: {
                type: String,
                required: true
            },
            /**
             * Scroll to comment on load
             */
            scrollToId: {
                type: Number,
                default: null
            }
        },

        data: () => ({
            comments: [],
            is_submitted: false
        }),

        methods: {
            /**
             * Get data
             *
             * @returns void
             */
            getData: async function() {
                try{
                    let result = await axios({
                        method: 'GET',
                        url: this.commentsUrl,
                        params: {
                        }
                    });

                    if (result.status === 200 && result.data) {
                        this.comments = result.data;
                    }
                }
                catch (e) {
                    console.log(e.message);
                }
            },

            /**
             * Like comment
             *
             * @param comment
             * @returns void
             */
            likeComment: async function(comment) {
                if (comment.like_url !== null && this.is_submitted === false) {
                    this.is_submitted = true;
                    try{
                        let result = await axios({
                            method: 'POST',
                            url: comment.like_url
                        });
                        if (result.status === 200 && result.data) {
                            if (result.data.success === true) {
                                comment.likes_count += 1;
                                comment.like_url = null;
                            }
                            if (result.data.message.length) {
                                flash(result.data.message, result.data.success ? 'success' : 'danger');
                            }
                        }
                        else {
                            flash('Došlo k chybě při zpracování požadavku.', 'danger');
                        }
                    }
                    catch (e) {
                        flash('Došlo k chybě při zpracování požadavku.', 'danger');
                        console.log(e.message);
                    }
                    this.is_submitted = false;
                }
            },

            /**
             * Delete comment
             *
             * @param comment
             * @returns void
             */
            deleteComment: async function(comment) {
                if (comment.delete_url !== null && this.is_submitted === false) {
                    let confirm = await this.$swal({
                        title: 'Opravdu chcete odstranit komentář?',
                        text: "Komentář a všechny reakce budou odstraněny.",
                        type: 'warning',
                        showCancelButton: true
                    });
                    if (confirm.value === true) {
                        this.is_submitted = true;
                        try{
                            let result = await axios({
                                method: 'DELETE',
                                url: comment.delete_url
                            });
                            if (result.status === 200 && result.data) {
                                if (result.data.success === true) {
                                    this.getData();
                                }
                                if (result.data.message.length) {
                                    flash(result.data.message, result.data.success ? 'success' : 'danger');
                                }
                            }
                            else {
                                flash('Došlo k chybě při zpracování požadavku.', 'danger');
                            }
                        }
                        catch (e) {
                            flash('Došlo k chybě při zpracování požadavku.', 'danger');
                            console.log(e.message);
                        }
                        this.is_submitted = false;
                    }
                }
            },

            /**
             * Get data and scroll to given comment by id
             *
             * @param id
             * @returns void
             */
            getDataAndScroll: async function(id) {
                await this.getData();
                setTimeout(() => {
                    if (this.$refs['comment-' + id]) {
                        this.$scrollTo(this.$refs['comment-' + id][0], 1000, {offset: -90});
                    }
                }, 100);
            }
        },

        computed: {
            commentsCount: function() {
                let repliesCount = this.comments.reduce((total, comment) => {
                    return total + comment.reactions.length;
                }, 0);
                return repliesCount + this.comments.length;
            }
        },

        watch: {
            // update comments count on parent instance
            commentsCount: function(val) {
                if (this.$parent.$refs.commentsCount) {
                    this.$parent.$refs.commentsCount.innerHTML = val;
                }
            }
        },

        mounted() {
            if (this.scrollToId !== null) {
                this.getDataAndScroll(this.scrollToId);
            }
            else {
                this.getData();
            }
        }
    }
</script>

<style scoped>

    .list-complete-enter-active, .list-complete-leave-active {
        transition: opacity .5s;
    }
    .list-completee-enter, .list-complete-leave-to {
        opacity: 0;
    }
</style>
